import { type ComponentPropsWithoutRef, forwardRef, useState } from 'react';

import { PaletteIcon } from '@air/design-icons';

import { CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER } from '~/constants/testIDs';

type CustomFieldModalColorMenuTriggerProps = {
  selectedColor: string;
  fontHex: string;
} & ComponentPropsWithoutRef<'button'>;

export const CustomFieldModalColorMenuTrigger = forwardRef<HTMLButtonElement, CustomFieldModalColorMenuTriggerProps>(
  ({ selectedColor, fontHex, ...props }: CustomFieldModalColorMenuTriggerProps, ref) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <button
        type="button"
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onMouseEnter={() => setIsHovered(true)}
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onMouseLeave={() => setIsHovered(false)}
        ref={ref}
        className="absolute top-1/2 left-2 flex size-6 -translate-y-1/2 cursor-pointer items-center justify-center rounded-4 border-0 bg-transparent p-0 text-inherit"
        data-testid={CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER}
        style={{
          backgroundColor: isHovered ? `color-mix(in hsl, ${selectedColor} 90%, black)` : selectedColor,
          color: fontHex,
        }}
        {...props}
        aria-label="Choose color"
      >
        <PaletteIcon size="sm" />
      </button>
    );
  },
);

CustomFieldModalColorMenuTrigger.displayName = 'CustomFieldModalColorMenuTrigger';
